export default class FilterPortifolio {
  constructor(type){
    this.type = type;
    this.portifolioItems = $('.portifolio').find('.items .item');

    switch(type){
      case "todos":
        this.all();
        break;
      default:
        this.filter();
        break;
    }
  }

  all(){
    this.portifolioItems.hide().fadeIn();
  }

  filter(){
    this.portifolioItems.fadeOut('slow');

    let itemFilter = $('.portifolio .items').find(`[data-filter*=${this.type}]`);
    itemFilter.map((i,e) => {
      $(e).stop().fadeIn('slow');
    });
  }

}



//////////////////
// WEBPACK FOOTER
// ./src/javascripts/filter_portifolio.js
// module id = 22
// module chunks = 0